import API from "../shared/API/apiClient";

// GET USERS
export const getUsers = async () => {
  try {
    const response = await API.get("/api/users");
    console.log("USER LIST API:", response.data);
    return response.data;
  } catch (error) {
    console.error("User API Error:", error);
    throw error;
  }
};

// TOGGLE STATUS
export const toggleUserStatus = async (userId) => {
  try {
    const res = await API.patch(`/api/users/${userId}/toggle-status`);
    return res.data;
  } catch (err) {
    console.error("Toggle status error:", err);
    throw err;
  }
};

// ADD USER
export const createUser = async (payload) => {
  try {
    const res = await API.post("/api/users", payload);
    return res.data;
  } catch (error) {
    console.error("CREATE USER ERROR:", error);
    throw error;
  }
};

// NEW: GET ROLES API
export const getRoles = async () => {
  try {
    const res = await API.get("/api/users/roles");
    return res.data;
  } catch (err) {
    console.error("Roles API Error:", err);
    throw err;
  }
};

//password
// GENERATE RESET LINK
export const generateResetLink = async (userId) => {
  const res = await API.post(`/api/users/${userId}/reset-password-link`);
  return res.data; // IMPORTANT
};



// RESET PASSWORD API
// export const resetPassword = async (payload) => {
//   try {
//     const res = await apiClient.post(
//       "/api/password/reset",
//       payload
//     );
//     return res.data;
//   } catch (error) {
//     throw error;
//   }
// };